import { render, staticRenderFns } from "./Email.html?vue&type=template&id=72f81b18&scoped=true&"
import script from "./Email.ts?vue&type=script&lang=ts&"
export * from "./Email.ts?vue&type=script&lang=ts&"
import style0 from "./Email.css?vue&type=style&index=0&id=72f81b18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f81b18",
  null
  
)

export default component.exports